import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { LISTING_CONDITION, LISTING_SALE_CLASS } from '../../../constants/listing.constants';
import DropdownFilter from '../DropdownFilter/DropdownFilter';
import useSearchParams from '../SearchFilters.hooks';
import { parse } from '../../../util/urlHelpers';

import css from './SearchPageStyles.module.css';

const SEARCH_PARAM_NAME = 'condition';

const conditions = Object.values(LISTING_CONDITION);

const ConditionFilter = () => {
  const intl = useIntl();
  const { search } = useSearchParams({
    searchParamName: SEARCH_PARAM_NAME,
  });
  const isUsedSaleClass = parse(search)?.saleClass === LISTING_SALE_CLASS.USED;

  const conditionDropdownOptions = useMemo(
    () =>
      conditions.map(condition => ({
        value: condition,
        label: intl.formatMessage({ id: `General.listing.condition.${condition}` }),
        searchString: intl.formatMessage({ id: `General.listing.condition.${condition}` }),
      })),
    []
  );

  if (!isUsedSaleClass) return null;

  return (
    <DropdownFilter
      options={conditionDropdownOptions}
      searchParamName={SEARCH_PARAM_NAME}
      placeholder={intl.formatMessage({ id: 'Global.condition' })}
      classNameLabel={css.dropdownLabel}
      disableFiltering
      searchable
    />
  );
};

export default ConditionFilter;
